import React, { Component } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { Input } from 'components/input';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { MAX_CUE_CHAR_AMOUNT } from '../constants';
import SubtitleActions from '../SubtitleActions';

@inject((stores) => ({
  currentCue: stores.SubtitleStore.currentCue
}))
@observer
export default class SubtitleCueEditor extends Component {
  static propTypes = {
    currentCue: PropTypes.object
  };

  get charCount() {
    const { content = '' } = this.props.currentCue;

    return MAX_CUE_CHAR_AMOUNT - content.length;
  }

  get isDisabled() {
    const { currentCue } = this.props;

    return typeof currentCue.content === 'undefined';
  }

  get className() {
    return classNames('subtitle__cue__editor', {
      'subtitle__cue__editor--active': !this.isDisabled
    });
  }

  shouldComponentUpdate(nextProps) {
    const { currentCue } = this.props;

    const isUpdatable = !(
      currentCue.id === nextProps.currentCue.id &&
      currentCue.content === nextProps.currentCue.id
    );

    return isUpdatable;
  }

  render() {
    const { content } = this.props.currentCue;

    return (
      <div className={this.className}>
        <Input
          className="subtitle__cue__editor__input"
          onChange={this.onChangeContent}
          handleKeyDown={this.onKeyDown}
          name="content"
          type="textarea"
          disabled={this.isDisabled}
          value={content}
        />

        <div className="subtitle__cue__editor__actions">
          <span className="subtitle__cue__editor__counter">
            {this.charCount}
          </span>

          <ButtonIcon
            round
            onClick={SubtitleActions.setNextCue}
            icon="next"
            className="subtitle__cue__editor__next"
          />
        </div>
      </div>
    );
  }

  onTab = (event) => {
    event.preventDefault();

    const isShiftTabKey = event.shiftKey;

    isShiftTabKey ? SubtitleActions.setPrevCue() : SubtitleActions.setNextCue();
  };

  onKeyDown = (event) => {
    const isTabKey = event.key === 'Tab';

    isTabKey && this.onTab(event);
  };

  onChangeContent = (event) => {
    const { currentCue } = this.props;
    const text = event.target.value;

    if (
      text.length <= MAX_CUE_CHAR_AMOUNT ||
      text.length < currentCue.content.length
    ) {
      SubtitleActions.modifyCue({ ...currentCue, content: text });
    }
  };
}
